<template>
  <div>
    <ASearchForm
      :modelName="'Cart'"
      :create="hasEditPermission"
      :dropdownProps="[{type:'text',name: 'Cart ID (contains)', payloadKey: 'nameLike'},
        {model:'contracts', name: 'Contract', payloadKey: 'contractId'}, 
        {model:'stations', name: 'Station', payloadKey: 'stationId'}, 
        {model:'states', name: 'Status', payloadKey: 'stateId'}, 
        {model:'modules', name: 'Module', payloadKey: 'moduleId'},
        {type:'text',name: 'Device #', payloadKey: 'deviceNumber'},
        {type:'text',name: 'Car #', payloadKey: 'car'},
        {type:'text',name: 'Missing Part', payloadKey: 'partId[]'},
        ]"
      @change="search"
      @create="onCreate"
      ref="ASearchForm"
      class="mb-5"
    ></ASearchForm>
    <ADataTable
      :headers="headers"
      :api="api"
      :sortBy="'cartSpecialId'"
      :editAction="hasEditPermission"
      :deleteAction="hasEditPermission"
      :actionsAtFirst="hasEditPermission"
      :tableWidth="2200"
      :freezeFirstNColumns="2"
      :exportable="true"
      @click:edit="onEdit"
      @click:delete="onDelete"
      :hideTitleBar="true"
      :apiParams="apiParams"
      ref="table"
    ></ADataTable>
    <AFormDialog
      ref="formDialog"
      :fields="formMeta"
      :modelName="'Cart'"
      :model="'carts'"
      :updateOnlyChanged="true"
      @modified="load"
    ></AFormDialog>
  </div>
</template>

<script>
import snackbar from "../mixins/snackbar";
import ConfirmDialogMixin from "../mixins/ConfirmDialogMixin";
import PermissionsHelper from "../mixins/PermissionsHelper";
import ASearchForm from "../components/ASearchForm";
import ADataTable from "../components/ADataTable";
import AFormDialog from "../components/AFormDialog";
import crudFuncsMixin from "../mixins/CRUDFuncs";
import formData from "./formdata/cart";

import { time, transformers } from "../utils";

export default {
  name: "Stations",
  mixins: [snackbar, ConfirmDialogMixin, crudFuncsMixin, PermissionsHelper],
  components: {
    ASearchForm,
    ADataTable,
    AFormDialog
  },
  data() {
    return {
      model: "carts",
      headers: [
        { text: "ID", value: "cartSpecialId" },
        { text: "Name", value: "name" },
        { text: "Display Name", value: "displayName" },
        {
          text: "Contract",
          value: "contractName",
          cusOrderByName: "contractId"
        },
        {
          text: "Location",
          value: "locationName",
          cusOrderByName: "locationId"
        },
        { text: "Station", value: "stationName", cusOrderByName: "stationId" },
        { text: "Status", value: "stateName", cusOrderByName: "stateId" },
        { text: "Car#", value: "car" },
        {
          text: "Missing Parts",
          value: "MissingPartsFormatted",
          sortable: false,
          format: {
            value: "missingParts",
            formatter: transformers.missingParts
          }
        },
        { text: "Module", value: "moduleName", cusOrderByName: "moduleId" },
        { text: "Pitch", value: "pitch" },
        { text: "Short String", value: "shortString" },
        { text: "LHG", value: "logisticsHandlingGroupName"},
        { text: "Device Number", value: "deviceNumber" },
        { text: "Version", value: "version" },
        {
          text: "Service Due",
          value: "serviceDueFomatted",
          cusOrderByName: "serviceDue",
          format: {
            value: "serviceDue",
            formatter: v => {
              return time.toDateFormat1(v);
            }
          }
        },
        {
          text: "Last Scan",
          value: "lastScanFormatted",
          cusOrderByName: "lastScan",
          format: {
            value: "lastScan",
            formatter: v => {
              return time.toTimestampFormat1(v);
            }
          }
        }
      ],
      apiParams: {},
      formMeta: formData.fields
    };
  },
  methods: {
    formatBeforeEdit(item) {
      item.serviceDue = time.toDateFormat2(item.serviceDue);
    },
    search(payload) {
      this.apiParams = payload;
    }
  }
};
</script>



